import { ReactNode } from 'react';

import { Widget } from '../widget/Widget';

import styles from './loginFrame.module.scss';

type LoginFrameProps = {
  children: ReactNode;
  title: string;
};

export function LoginFrame({ children, title }: LoginFrameProps) {
  return (
    <div className={styles['root']}>
      <Widget title={title}>
        <div className={styles['content']}>{children}</div>
      </Widget>
    </div>
  );
}
